import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const COLORS = ["#6f3fec", "#22c55e", "#ef4444", "#f97316", "#3b82f6", "#a855f7", "#facc15", "#22d3ee"];

export const ConfettiBurst = ({ trigger = 0, count = 60, duration = 1.6 }) => {
    const [pieces, setPieces] = useState([]);
    useEffect(() => {
        if (!trigger) return;
        const arr = Array.from({ length: count }).map((_, i) => ({
            id: `${trigger}-${i}`,
            x: 50 + (Math.random() - 0.5) * 30,
            y: 50,
            dx: (Math.random() - 0.5) * 240,
            dy: -260 - Math.random() * 220,
            rot: Math.random() * 360,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            size: 6 + Math.random() * 8,
            shape: Math.random() > 0.5 ? "sq" : "rect",
        }));
        setPieces(arr);
        const id = setTimeout(() => setPieces([]), duration * 1000 + 400);
        return () => clearTimeout(id);
    }, [trigger, count, duration]);

    return (
        <div className="pointer-events-none fixed inset-0 z-[60]" data-testid="confetti-burst">
            <AnimatePresence>
                {pieces.map((p) => (
                    <motion.span
                        key={p.id}
                        initial={{ x: `${p.x}vw`, y: `${p.y}vh`, opacity: 1, rotate: 0 }}
                        animate={{ x: `calc(${p.x}vw + ${p.dx}px)`, y: `calc(${p.y}vh + ${p.dy}px + 100vh)`, opacity: 0, rotate: p.rot * 4 }}
                        transition={{ duration, ease: "easeOut" }}
                        exit={{ opacity: 0 }}
                        style={{
                            position: "absolute",
                            background: p.color,
                            width: p.shape === "sq" ? p.size : p.size * 1.6,
                            height: p.size,
                            borderRadius: 2,
                            boxShadow: `0 0 8px ${p.color}aa`,
                        }}
                    />
                ))}
            </AnimatePresence>
        </div>
    );
};
